<template>
    <section class="bg-black">
        <div class="px-4 py-8 mx-auto max-w-5xl lg:py-16 xl:px-0">
            <h3 class="text-white md:mb-12 mb-6 text-3xl md:text-4xl font-ww-bold md-max:!leading-7 xl:!leading-none xl:text-42 text-center md:text-left" v-html="mainHeading">
            </h3>
            <div class="text-base text-white font-ww-regular md:text-lg" v-html="introText">
            </div>
            <div class="grid grid-cols-1 gap-x-4 gap-y-4 mt-8 lg:mt-16 md:grid-cols-2 md:gap-x-8 md:gap-y-8">
                <div v-for="(item, index) in bundleItems" :key="index" class="relative min-h-64">
                    <div class="absolute inset-0">
                        <div class="h-full">
                            <nuxt-img :src="backgroundImage" :alt="backgroundImageAlt" loading="lazy"
                                :width="backgroundImageWidth" :height="backgroundImageHeight" class="w-full h-full sm-max:object-cover" />
                        </div>
                    </div>
                    <div class="z-20 py-6 pr-3 pl-3 h-full lg:pr-6 lg:pl-8">
                        <div class="flex relative z-20 flex-col gap-y-4 justify-between items-center h-full lg:items-end lg:flex-row">
                            <a v-if="item.href" :href="item.href" class="block">
                                <nuxt-img :src="item.image" :alt="item.alt" loading="lazy"
                                    :width="item.width" :height="item.height" sizes="xs:251px sm:251px md:251px lg:251px xl:251px" class="object-contain mx-auto h-full xl:max-w-auto lg:max-w-80" />
                            </a>
                            <nuxt-img v-else :src="item.image" :alt="item.alt" loading="lazy"
                                :width="item.width" :height="item.height" sizes="xs:251px sm:251px md:251px lg:251px xl:251px" class="object-contain mx-auto h-full xl:max-w-auto lg:max-w-80" />
                            <div>
                                <div v-if="item.additionalImages && item.additionalImages.length > 0" class="flex gap-x-4 justify-end md-max:mb-3">
                                    <a v-for="(addImg, imgIndex) in item.additionalImages" :key="imgIndex" :href="addImg.href" class="block" target="_blank">   
                                        <nuxt-img :src="addImg.src" :alt="addImg.alt" loading="lazy"
                                        :width="addImg.width" :height="addImg.height" class="object-contain h-full md-max:mx-auto" />
                                    </a>
                                </div>
                                <div class="text-lg leading-6 text-center xl:text-2xl md:text-xl lg:text-right font-ww-bold" :class="item.maxWidth ? item.maxWidth : ''" v-html="item.name">
                                </div>
                                <div class="bg-[#F3A9B3] md:text-lg text-lg font-ww-bold mt-3 md:py-2 py-1 md:px-4 px-2 w-fit md:float-right md-max:mx-auto">
                                    value: {{ item.value }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <ul class="space-y-3 text-base md:text-lg">
                        <li v-for="(item, index) in bundleItems" :key="index" class="flex justify-between items-center w-full text-white text-balance">
                            <span class="flex gap-x-2 items-center text-sm whitespace-nowrap font-ww-bold sm:text-base lg:text-17 !leading-4" v-html="item.name">
                            </span>
                            <div class="relative -bottom-2 flex-grow mx-2 border-b border-white"></div>
                            <span class="text-sm whitespace-nowrap lg:text-lg font-ww-regular sm:text-base"> value: {{ item.value }}</span>
                        </li>
                    </ul>
                    <div class="mt-4 w-full h-0.5 bg-white"></div>
                    <div class="mt-1 w-full h-0.5 bg-white"></div>
                    <div class="mt-4 text-2xl text-right text-white lg:text-3xl font-ww-bold">
                        {{ totalValue }}
                    </div>
                </div>
            </div>
            <div class="text-white md:mb-6 mb-3 text-3xl md:text-4xl font-ww-bold xl:!leading-none xl:text-42 text-center mt-16" v-html="bottomHeading">
            </div>
            <div class="flex justify-center items-center text-3xl xl:text-42 md:text-4xl">
                <span class="text-white line-through font-ww-regular">
                    {{ oldPrice }}
                </span>
                <span class="text-white font-ww-regular">
                    {{ newPrice }}
                </span>
            </div>
            <div class="mt-3 text-base text-center text-white md:text-lg font-ww-regular" v-html="servingText">
            </div>
            <div class="mt-4 text-center md:mt-10">
                <button @click="scrollTo(buttonHref,'bottom')" class="inline-flex justify-center items-center px-8 py-4 text-lg font-bold text-white rounded-full transition-colors duration-200 lg:w-6/12 font-ww-medium btn-red hover:bg-red-600">
                    {{ buttonText }}
                    <svg class="ml-2 w-5 h-5" width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3007 0.50283C13.2069 0.595793 13.1325 0.706394 13.0818 0.828253C13.031 0.950112 13.0049 1.08082 13.0049 1.21283C13.0049 1.34484 13.031 1.47555 13.0818 1.59741C13.1325 1.71927 13.2069 1.82987 13.3007 1.92283L17.9007 6.52283L1.5 6.33529C1.23478 6.33529 0.98043 6.44065 0.792893 6.62819C0.605357 6.81572 0.5 7.07008 0.5 7.33529C0.5 7.60051 0.605357 7.85486 0.792893 8.0424C0.98043 8.22994 1.23478 8.33529 1.5 8.33529L17.8807 8.52283L13.3007 13.0928C13.1144 13.2802 13.0099 13.5336 13.0099 13.7978C13.0099 14.062 13.1144 14.3155 13.3007 14.5028C13.488 14.6891 13.7415 14.7936 14.0057 14.7936C14.2699 14.7936 14.5233 14.6891 14.7107 14.5028L21.0707 8.14283C21.1563 8.0607 21.2244 7.96211 21.2709 7.85299C21.3174 7.74386 21.3414 7.62646 21.3414 7.50783C21.3414 7.3892 21.3174 7.2718 21.2709 7.16267C21.2244 7.05355 21.1563 6.95496 21.0707 6.87283L14.7207 0.50283C14.6277 0.409101 14.5171 0.334707 14.3952 0.283938C14.2734 0.23317 14.1427 0.207031 14.0107 0.207031C13.8787 0.207031 13.748 0.23317 13.6261 0.283938C13.5042 0.334707 13.3936 0.409101 13.3007 0.50283Z" fill="white"/>
                    </svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
  mainHeading: {
    type: String,
    default: 'Order Mindflow Today and Get the Morning Upgrade Kit for FREE!'
  },
  introText: {
    type: String,
    default: 'Because this is the first time we\'re sharing Mindflow with the world, we want to upgrade your morning and your life.<br><br>When you order Mindflow today as a new customer, you get ALL of the following INCLUDED:'
  },
  backgroundImage: {
    type: String,
    default: '/assets/images/bg-mindflow-grid.png'
  },
  backgroundImageAlt: {
    type: String,
    default: 'Background Grid'
  },
  backgroundImageWidth: {
    type: Number,
    default: 461
  },
  backgroundImageHeight: {
    type: Number,
    default: 266
  },
  bundleItems: {
    type: Array,
    default: () => [
      {
        name: 'Mindflow (3 bags)',
        value: '$119.97',
        image: '/assets/images/mindflow-3x.png',
        alt: 'Mindflow 3 bags',
        width: 251,
        height: 204,
        href: ''
      },
      {
        name: 'Metal Scooper',
        value: '$25',
        image: '/assets/images/metal-scooper.png',
        alt: 'Metal Scooper',
        width: 203,
        height: 231,
        href: ''
      },
      {
        name: 'Habit-Tracking App',
        value: '$35',
        image: '/assets/images/habit-tracking.png',
        alt: 'Habit Tracking App',
        width: 159,
        height: 160,
        href: '',
        additionalImages: [
          {
            src: '/assets/images/mac.png',
            alt: 'Mac compatible',
            width: 47,
            height: 48,
            href: 'https://apps.apple.com/us/app/habits-dont-break-the-chain/id6741651253'
          },
          {
            src: '/assets/images/windows.png',
            alt: 'Windows compatible',
            width: 47,
            height: 48,
            href: 'https://play.google.com/store/apps/details?id=com.app.habitbuilder'
          }
        ]
      },
      {
        name: 'Coffee Recipe Book',
        value: '$30',
        image: '/assets/images/books-brain.png',
        alt: 'Coffee Recipe Book',
        width: 310,
        height: 179,
        href: ''
      },
      {
        name: 'Everlo Remineralization <br> Coffee Upgrade Drops',
        value: '$40',
        image: '/assets/images/everlo.png',
        alt: 'Everlo Drops',
        width: 72,
        height: 214,
        maxWidth: 'max-w-60',
        href: ''
      }
    ]
  },
  totalValue: {
    type: String,
    default: 'Total $249+'
  },
  bottomHeading: {
    type: String,
    default: 'Get the full Morning Upgrade Kit for only…'
  },
  oldPrice: {
    type: String,
    default: '$249'
  },
  newPrice: {
    type: String,
    default: '$24.99/bag!'
  },
  servingText: {
    type: String,
    default: '(That\'s less than $1.00 per serving!)'
  },
  buttonText: {
    type: String,
    default: 'ORDER NOW'
  },
  buttonHref: {
    type: String,
    default: 'products'
  }
})

defineBuilderComponent({
    friendlyName: 'Bundle Offer Showcase',
    canHaveChildren: false,
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'Order Mindflow Today and Get the Morning Upgrade Kit for FREE!'
        },
        {
            name: 'introText',
            type: 'richText',
            defaultValue: 'Because this is the first time we\'re sharing Mindflow with the world, we want to upgrade your morning and your life.<br><br>When you order Mindflow today as a new customer, you get ALL of the following INCLUDED:'
        },
        {
            name: 'backgroundImage',
            type: 'file',
            defaultValue: '/assets/images/bg-mindflow-grid.png'
        },
        {
            name: 'backgroundImageAlt',
            type: 'text',
            defaultValue: 'Background Grid'
        },
        {
            name: 'backgroundImageWidth',
            type: 'number',
            defaultValue: 461
        },
        {
            name: 'backgroundImageHeight',
            type: 'number',
            defaultValue: 266
        },
        {
            name: 'bundleItems',
            type: 'list',
            subFields: [
                {
                    name: 'name',
                    type: 'richText'
                },
                {
                    name: 'value',
                    type: 'text'
                },
                {
                    name: 'image',
                    type: 'file'
                },
                {
                    name: 'alt',
                    type: 'text'
                },
                {
                    name: 'width',
                    type: 'number'
                },
                {
                    name: 'height',
                    type: 'number'
                },
                {
                    name: 'maxWidth',
                    type: 'text'
                },
                {
                    name: 'href',
                    type: 'text'
                },
                {
                    name: 'additionalImages',
                    type: 'list',
                    subFields: [
                        {
                            name: 'src',
                            type: 'file'
                        },
                        {
                            name: 'alt',
                            type: 'text'
                        },
                        {
                            name: 'width',
                            type: 'number'
                        },
                        {
                            name: 'height',
                            type: 'number'
                        },
                        {
                            name: 'href',
                            type: 'text'
                        }
                    ]
                }
            ],
            defaultValue: [
                {
                    name: 'Mindflow (3 bags)',
                    value: '$119.97',
                    image: '/assets/images/mindflow-3x.png',
                    alt: 'Mindflow 3 bags',
                    width: 251,
                    height: 204,
                    href: ''
                },
                {
                    name: 'Metal Scooper',
                    value: '$25',
                    image: '/assets/images/metal-scooper.png',
                    alt: 'Metal Scooper',
                    width: 203,
                    height: 231,
                    href: ''
                },
                {
                    name: 'Habit-Tracking App',
                    value: '$35',
                    image: '/assets/images/habit-tracking.png',
                    alt: 'Habit Tracking App',
                    width: 159,
                    height: 160,
                    href: '',
                    additionalImages: [
                        {
                            src: '/assets/images/mac.png',
                            alt: 'Mac compatible',
                            width: 47,
                            height: 48,
                            href: 'https://apps.apple.com/us/app/habits-dont-break-the-chain/id6741651253'
                        },
                        {
                            src: '/assets/images/windows.png',
                            alt: 'Windows compatible',
                            width: 47,
                            height: 48,
                            href: 'https://play.google.com/store/apps/details?id=com.app.habitbuilder'
                        }
                    ]
                },
                {
                    name: 'Coffee Recipe Book',
                    value: '$30',
                    image: '/assets/images/books-brain.png',
                    alt: 'Coffee Recipe Book',
                    width: 310,
                    height: 179,
                    href: ''
                },
                {
                    name: 'Everlo Remineralization <br> Coffee Upgrade Drops',
                    value: '$40',
                    image: '/assets/images/everlo.png',
                    alt: 'Everlo Drops',
                    width: 72,
                    height: 214,
                    maxWidth: 'max-w-60',
                    href: ''
                }
            ]
        },
        {
            name: 'totalValue',
            type: 'text',
            defaultValue: 'Total $249+'
        },
        {
            name: 'bottomHeading',
            type: 'richText',
            defaultValue: 'Get the full Morning Upgrade Kit for only…'
        },
        {
            name: 'oldPrice',
            type: 'text',
            defaultValue: '$249'
        },
        {
            name: 'newPrice',
            type: 'text',
            defaultValue: '$24.99/bag!'
        },
        {
            name: 'servingText',
            type: 'richText',
            defaultValue: '(That\'s less than $1.00 per serving!)'
        },
        {
            name: 'buttonText',
            type: 'text',
            defaultValue: 'ORDER NOW'
        },
        {
            name: 'buttonHref',
            type: 'text',
            defaultValue: 'products'
        }
    ]
})
</script>